import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PortalLoginV2Page } from "@/components/v2/pages/portal-login-v2-page";

const loginSearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: loginSearchSchema,
  component: PortalLoginV2Page,
});
